import * as angular from 'angular';
import * as moment from 'moment';
import EditPalletKPIsName, { openEditPalletKpi } from "./editPalletKpi.controller";
import { States } from "../../shared/config/constant.module";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import { Plant } from "../../models/navigation";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NotifyServiceName, { NotifyService } from '../../services/notify/notify.service';
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import * as _ from "lodash";
import template from './palletKPIs.tpl.html';

let requires = [LoaderServiceName, ReportServiceName, NavigationServiceName, EditPalletKPIsName,
  AuthDataServiceName, NotifyServiceName];

export default angular.module('aps.controller.palletKPIs', requires)
  .config(palletizerKpisConfig)
  .controller('PalletKpisCtrl', palletKpisController)
  .name;

function palletizerKpisConfig($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.PALLETKPI,
    url: '/admin/palletkpis',
    controller: 'PalletKpisCtrl as vm',
    template: template,
    data: {
      pageTitle: 'Pallet Edit'
    }
  });
}

interface PalletKpisController {
  palletKPIs: apsViewModels.PlantKpiItem[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  plants: Plant[];
  generateReport(): void;
  reportDate: Date;
  edit(instance: apsViewModels.PlantKpiItem): void;
  minDate: Date;
}

function palletKpisController(loaderService: LoaderService,
  reportService: ReportService,
  notifyService: NotifyService,
  navigationService: NavigationService,
  authDataService: AuthDataService,
  $modal: mm.foundation.modal) {
  let vm = {} as PalletKpisController;

  var dtToday = new Date();
  var day = dtToday.setDate(dtToday.getDate() - 1);
  let loadingPromise = navigationService.getNavigation().then(nav => {
    let plants = nav.plants();
    //    vm.plants = _.filter(plants, (plant: Plant) =>
    //      authDataService.isAPSIOAdminForPlant(plant.id)
    //    );
    vm.plants = plants;
    if (nav.selectedPlant && _.includes(vm.plants, nav.selectedPlant)) {
      vm.selectedPlant = nav.selectedPlant;
    } else {
      vm.selectedPlant = _.first(vm.plants);
      vm.selectedShop = nav.selectedShop;
    }


  });

  loaderService.loadingPromise(loadingPromise);

  vm.edit = edit;
  vm.reportDate = moment().add(-1, 'days').toDate();
  vm.minDate = moment().add(-14, 'days').toDate();
  vm.generateReport = generateReport;
  return vm;

  function generateReport(): angular.IPromise<any> {
    var promise = runReport();
    loaderService.loadingPromise(promise);
    return promise;
  }
  function runReport(): angular.IPromise<any> {

    return reportService.getPlantKpis(vm.selectedShop.id, vm.reportDate).then(reportItem => {
      vm.palletKPIs = reportItem;
    }, notifyService.handleApiErrors);

  }

  function edit(instance: apsViewModels.PlantKpiItem): void {
    let result = openEditPalletKpi({
      plant: vm.selectedPlant,
      palletKpiItem: instance,
      productionDate: vm.reportDate
    }, $modal);
    result.then((result) => {
      if (!result) {
        return;
      }

      vm.palletKPIs.splice(vm.palletKPIs.indexOf(instance), 1, result);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/controllers/reports/palletKpis.controller.ts